import { configureStore } from '@reduxjs/toolkit';
import authReducer from './authSlice';
import screenReducer from './screenSlice';
import availabilityReducer from './availabilitySlice';
import searchSlice from './searchSlice';
import homeSlice from './homeSlice';
import { listenerMiddleware } from './middleware/listenerMiddleware';
import { apiSlice } from './api/apiSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    screen: screenReducer,
    availability: availabilityReducer,
    search: searchSlice,
    home: homeSlice,
    [apiSlice.reducerPath]: apiSlice.reducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .prepend(listenerMiddleware.middleware)
      .concat(apiSlice.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
